import { render } from "./LinksSection.vue?vue&type=template&id=46195ea4&scoped=true"
import script from "./LinksSection.vue?vue&type=script&lang=js"
export * from "./LinksSection.vue?vue&type=script&lang=js"

import "./LinksSection.vue?vue&type=style&index=0&id=46195ea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46195ea4"]])

export default __exports__